import type { AssistProfile, Player } from "@golazo/shared";

/**
 * Lo unico que queda de la asistencia al humano. El iman de pase y tiro se
 * quito el 2026-08-26: el golpeo sale a donde apuntas, sin que el juego
 * corrija la direccion hacia el mejor companero o el mejor hueco.
 */
export function forgiveTrap(player: Player, assist: AssistProfile): void {
  if (player.trapTime <= 0 || assist.trapScale >= 0.999) return;
  player.trapTime *= assist.trapScale;
}
